module.exports = __webpack_public_path__ + "img/97.a1a908c4.jpg";